const modules = import.meta.glob('/node_modules/@ant-design/icons-vue/es/icons/*.js', {
  eager: true,
})

export const iconMap = {}

for (const path in modules) {
  const iconName = path.split('/').pop().replace('.js', '')
  // 根据实际导出方式调整，假设为默认导出
  iconMap[iconName] = modules[path].default
}
